import { render, staticRenderFns } from "./DokterTelemedicine.vue?vue&type=template&id=50b0d4c6"
import script from "./DokterTelemedicine.vue?vue&type=script&lang=js"
export * from "./DokterTelemedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports